import * as React from 'react';
import { ICommand } from '../../../models/commands/ICommand';
import { Facet } from '../../../models/Facet';
import { IContextualMenuItem } from 'office-ui-fabric-react/lib/ContextualMenu';
import { SwitchLayoutAction } from '../../actions/switchLayout/SwitchLayoutAction';
import { detailsLayoutType, compactDetailsLayoutType } from '../../layouts/DetailsLayoutTypeFacet';
import { tilesLayoutType } from '../../layouts/TilesLayoutTypeFacet';
import CommandStrings from '../Commands.resx';

export const switchLayoutCommand: ICommand = {
  key: new Facet('switchLayout').id,
  automationId: 'switchLayoutCommand',
  title: CommandStrings.SwitchLayoutCommandLabel,
  ariaLabel: CommandStrings.SwitchLayoutCommandLabel,
  iconProps: {
    iconName: 'tiles'
  },
  postProcess: (item: IContextualMenuItem): IContextualMenuItem => {
    const items = item.subMenuProps && item.subMenuProps.items;

    const currentCommand = items && items.filter((i: IContextualMenuItem) => i.checked)[0];

    return {
      ...item,
      ...(items && items.length === 1 ? {
        subMenuProps: undefined,
        disabled: true
      } : {}),
      ...(currentCommand ? {
        iconProps: currentCommand.iconProps
      } : {})
    };
  },
  subMenuProps: {
    items: [
      {
        key: new Facet('detailsList').id,
        automationId: 'detailsListCommand',
        name: CommandStrings.ViewList,
        title: CommandStrings.ViewListCommandTooltip,
        action: <SwitchLayoutAction layoutType={ detailsLayoutType } />,
        iconProps: {
          iconName: 'list'
        }
      },
      {
        key: new Facet('compactDetailsList').id,
        automationId: 'compactDetailsListCommand',
        name: CommandStrings.ViewCompactList,
        title: CommandStrings.ViewCompactListCommandTooltip,
        action: <SwitchLayoutAction layoutType={ compactDetailsLayoutType } />,
        iconProps: {
          iconName: 'alignleft'
        }
      },
      {
        key: new Facet('tilesList').id,
        automationId: 'tilesListCommand',
        name: CommandStrings.ViewGrid,
        title: CommandStrings.ViewGridCommandTooltip,
        action: <SwitchLayoutAction layoutType={ tilesLayoutType } />,
        iconProps: {
          iconName: 'viewall',
        }
      }
    ]
  }
};
